import { render, staticRenderFns } from "./FileField.vue?vue&type=template&id=62cf58b9&scoped=true"
import script from "./FileField.vue?vue&type=script&lang=js"
export * from "./FileField.vue?vue&type=script&lang=js"
import style0 from "./FileField.vue?vue&type=style&index=0&id=62cf58b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62cf58b9",
  null
  
)

export default component.exports